import RemoteServices from '~/constants/RemoteServices';
import MMSClient from 'mms_client_js';

export default new MMSClient(`${RemoteServices.products}/api/out`);
